import { makeAutoObservable } from "mobx";

class AnalysisPagesStore {
    nodeId = ""
    communityId = ""
    startDate = ""
    endDate = ""
    analysisType=""
    mod = 2
    step = 7200

    constructor() {
        makeAutoObservable(this);
    }
    setNodeId (id){
        this.nodeId = id
    }
    setCommunityId (id){
        this.communityId = id
    }
    setStartDate (date){
        this.startDate = date
    }
    setEndDate (date){
        this.endDate = date
    }
    setAnalysisType(type){
        this.analysisType = type
    }
    setMod (mod){
        mod > 0 ? this.mod = mod : this.mod = 1        
    }
    setStep (step){
        step>0?this.step = step:this.step=1
    }
}

const analysisPagesStore = new AnalysisPagesStore();
export default analysisPagesStore;